import { GROUP_TYPES } from "../types/dist/constants.js";
import { Type } from "js-yaml";
import { shortHash } from "../utils/hash.js";
import { ParsedDataSource } from "./data_source.js";
const represent = (parsedCard) => {
  const {
    id,
    width,
    height,
    variant,
    maxHeight,
    maxWidth,
    data,
    components,
    conditions,
    slots,
    goals,
    collapsible
  } = parsedCard;
  return {
    id: id?.startsWith("$tmp:") ? void 0 : id,
    width,
    height,
    variant,
    "max-height": maxHeight,
    maxWidth,
    data: data instanceof ParsedDataSource ? data : void 0,
    components,
    conditions: conditions ? conditions : void 0,
    slots,
    goals,
    collapsible
  };
};
class ParsedCard {
  id;
  maxHeight;
  maxWidth;
  width;
  height;
  collapsible;
  type = GROUP_TYPES.card;
  variant;
  data;
  components;
  goals;
  slots;
  conditions;
  constructor(parsedCard) {
    this.id = parsedCard.id || `$tmp:${shortHash(JSON.stringify(parsedCard))}`;
    this.width = parsedCard.width ?? void 0;
    this.height = parsedCard.height ?? void 0;
    this.variant = parsedCard.variant || void 0;
    this.maxHeight = parsedCard["max-height"] || void 0;
    this.maxWidth = parsedCard.maxWidth || void 0;
    this.data = parsedCard.data instanceof ParsedDataSource ? parsedCard.data : void 0;
    this.goals = parsedCard.goals || void 0;
    this.components = parsedCard.components || void 0;
    this.conditions = parsedCard.conditions || void 0;
    this.slots = parsedCard.slots || void 0;
    this.collapsible = parsedCard.collapsible || void 0;
  }
}
const CardTag = new Type("!card", {
  kind: "mapping",
  resolve: (data) => data !== null,
  construct: (data) => new ParsedCard(data),
  // predicate: (value: string) => typeof value === 'string' && value.startsWith('!:'),
  instanceOf: ParsedCard,
  represent
});
export {
  CardTag,
  ParsedCard
};
